<template>
  <div class="nav-container">
    <nav>
      <div class="navbar">
        <!-- Left side -->
        <div class="nav-left">
          <NavigationBarDropdown title="About" :items="about" class="nav-item" />
          <NavigationBarDropdown title="Learn" :items="learn" class="nav-item" />
          <NavigationBarDropdown title="Media" :items="media" class="nav-item" />
        </div>

        <!-- Center logo -->
        <router-link to="/" class="logo-container">
          <img src="@/../public/assets/new_logo.png" alt="Logo" />
        </router-link>

        <!-- Right side -->
        <div class="nav-right">
          <NavigationBarDropdown title="Connect" :items="connect" class="nav-item" />
          <NavigationBarDropdown title="Resources" :items="resources" class="nav-item" />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import NavigationBarDropdown from './NavigationBarDropdown.vue';

export default {
  components: {
    NavigationBarDropdown
  },

  data() {
    return {
      about: [
        { title: "About This Site", link: "/about-this-site" },
        { title: "Meet The Team", link: "/meet-the-team" }
      ],
      learn: [
        { title: "Personal Testimonies", link: "/personal-testimonies" },
        { title: "The Rosenstrasse Protest", link: "/the-rosenstrasse-protest" },
        { title: "Timeline", link: "/timeline" },
        { title: "UROP Research", link: "/urop-research" }
      ],
      media: [
        { title: "Social Media", link: "/social-media" },
        { title: "Monthly Civil Courage Report", link: "/monthly-newsletters" }
      ],
      connect: [
        { title: "Contact Us", link: "/contact-us" },
        { title: "Donate", link: "/donate" },
        { title: "News & Events", link: "/events" }
      ],
      resources: [
        { title: "Documents", link: "/documents" },
        { title: "Events & Interpretations of the Protest", link: "/forum" },
        { title: "Media Resources", link: "/media-resources" },
        { title: "Sources Cited", link: "/sources-cited" },
        { title: "Scholarly Debate", link: "/scholarly-debate" }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/_shared.scss";

.nav-container {
  background-color: $navy;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
}

nav {
  height: 140px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.nav-left,
.nav-right {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  img {
    width: 170px;
    height: 160px;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
}

.nav-item {
  position: relative;
  color: white !important;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 25px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 30px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background-color: #006272;
    color: white !important;
  }

  &.active {
    background-color: #006272;
    color: white !important;
  }

  ::v-deep .nav-dropdown-button {
    background: none;
    padding: 0;

    svg {
      display: none;
    }
  }
}

@media only screen and (max-width: 900px) {
  nav {
    height: auto;
    padding: 8px 0;
  }

  .navbar {
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    padding: 0 10px;
  }

  .logo-container {
    order: -1;
    width: 100%;
  }

  .nav-left,
  .nav-right {
    justify-content: center;
    gap: 12px;
    width: 100%;
  }

  .logo-container img {
    width: 60px;
    height: 55px;
  }

  .nav-item {
    font-size: 14px;
    padding: 6px 16px;
  }
}

@media only screen and (max-width: 600px) {
  .navbar {
    gap: 8px;
    padding: 0 6px;
  }

  .nav-left,
  .nav-right {
    gap: 8px;
  }

  .nav-item {
    font-size: 12px;
    padding: 4px 8px;
  }
}
</style>